module.exports = __webpack_public_path__ + "img/calenNoti.f612d4a7.svg";